import { Theme, createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 300,
      maxHeight: 320,
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0.5, 1),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    headerLabel: {
      marginLeft: theme.spacing(0.5),
      fontWeight: 500,
    },
    list: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    groupRow: {
      paddingRight: theme.spacing(1),
    },
    groupChevron: {
      color: theme.palette.text.secondary,
      flexShrink: 0,
      marginLeft: 'auto',
    },
    selectedCount: {
      marginRight: theme.spacing(0.25),
    },
    centered: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
  }),
);
